module.exports = __webpack_public_path__ + "assets/img/banner.a0c93051.jpg";